export default function($) {
  var speed = 90; // ms

  function applyDropdownBehavior() {
    $('.value-dropdown-wrapper').each(function(index) {
      if (index === 0) {
        $(this).find('.value-dropdown').show();
        $(this).find('.js-value-summary').show();
        $(this).addClass('open');
      } else {
        $(this).find('.value-dropdown').hide();
        $(this).find('.js-value-summary').show();
      }
    });
  }

  function scrollToElementIfNeeded(element) {
    var offsetTop = element.offset().top;
    var scrollTop = $(window).scrollTop();
    var windowHeight = $(window).height();
    var elementHeight = element.outerHeight();

    if (offsetTop < scrollTop || offsetTop + elementHeight > scrollTop + windowHeight) {
      $('html, body').animate({ scrollTop: offsetTop }, speed);
    }
  }

  function adjustScrollForAnchors() {
    $('a[href^="#"]').click(function(event) {
      var target = $($(this).attr('href'));
      if (target.length) {
        event.preventDefault();
        var offsetTop = target.offset().top;
        $('html, body').animate({ scrollTop: offsetTop }, speed);
      }
    });
  }

  applyDropdownBehavior();
  adjustScrollForAnchors();

  $('.js-value-dropdown-button').click(function() {
    var wrapper = $(this).closest('.value-dropdown-wrapper');
    var dropdown = wrapper.find('.value-dropdown');
    var isOpen = wrapper.hasClass('open');

    $('.value-dropdown').not(dropdown).slideUp(speed);
    $('.js-value-summary').not('.js-value-summary').show();
    $('.value-dropdown-wrapper.open').not(wrapper).removeClass('open');

    dropdown.slideToggle(speed, function() {
      if (dropdown.is(':visible')) {
        scrollToElementIfNeeded(wrapper);
      }
    });


      $('.js-value-summary').show();
      wrapper.toggleClass('open', !isOpen);
  });
}
